import React from 'react';
import { Field } from 'formik';
import withMapping from '../../../Context/withMapping';
import GenericFormElement from '../GenericFormElement';
import './style.scss';

var TextField = function TextField(props) {
  var title = props.title,
      required = props.required,
      description = props.description,
      placeholder = props.placeholder,
      fieldName = props.fieldName,
      validation = props.validation,
      touched = props.touched,
      error = props.error,
      value = props.value,
      displayRequiredIndicator = props.displayRequiredIndicator;
  var type = props.type || "text";
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: "TextField",
    title: title,
    required: required,
    description: description,
    fieldName: fieldName,
    touched: touched,
    error: error,
    displayRequiredIndicator: displayRequiredIndicator
  }, /*#__PURE__*/React.createElement(Field, {
    className: error && touched ? 'error' : null,
    name: fieldName,
    type: type,
    value: value,
    placeholder: placeholder,
    validate: validation
  }));
};

export default withMapping(TextField);